<template>
    <div class="home-page">
        <div>
            <div @click="back" class="back">
                <img src="@/assets/imgs/back_r.png" alt="">
                <span>返回系统</span>
            </div>

        </div>
        <div class="title">
            <h1>{{row.title}}</h1>
            <h2>{{row.name}}</h2>
        </div>
        <el-carousel :initial-index="page" :autoplay="false" indicator-position="none" arrow="never" ref="time"
                     height="70vh" @change="change">
            <el-carousel-item v-for="(item,index) in list" :key="index">
                <div class="list">

                    <div v-for="(sitem,sindex) in item" :key="sindex" class="sing">
                        <div class="raidius">
                            <span class="yuan"></span>
                            <span class="xian"></span>
                            <img src="@/assets/imgs/dot.png" alt="" class="dot">
                        </div>

                        <div class="content">
                            <p>{{sitem.name}}</p>
                            <p class="h1">{{sitem.title}}</p>
                            <img :src="'https://www.bndj.ncsvrcom.com'+sitem.image" alt="" class="photo">
                            <div :class="sindex%2==0?'odd':'even'" class="more" @click="nextPage(sitem)">
                                <img src="@/assets/imgs/arrow_w.png" alt="" v-if="sindex%2!=0">
                                <img src="@/assets/imgs/arrow_red.png" alt="" v-else>
                            </div>
                        </div>

                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>


        <img src="@/assets/imgs/pre.png" alt="" class="pre" @click="pre">
        <img src="@/assets/imgs/next.png" alt="" class="next" @click="next">
    </div>
</template>

<script>
    import {save_visit, timeline} from '@/api/module/api'

    export default {
        name: "home",

        data() {
            return {
                list: [],
                page: this.$route.query.page ? Number(this.$route.query.page) : 0,
                row: {}
            }
        },
        watch: {
            $route: { // 监听路由的参数变化
                handler () { // 数据变化更新数据
                 console.log()
                    this.$refs.time.setActiveItem(this.$route.query.page)
                },
                immediate: true // 立即执行
            }
        },created() {
            this.savePage();
            this.getIndex();

        },
        methods: {
            async savePage() {
                const {data} = await save_visit({
                    type: 3,
                    page: this.page,
                    visit_id: this.$route.query.visit_id
                })
            },
            async getIndex() {
                const {data} = await timeline({id: this.$route.query.visit_id});
                let result = []
                for (let i = 0; i < data.list.length; i += 5) {
                    result.push(data.list.slice(i, i + 5));
                }
                this.list = result;
                this.row = data.row;
            },
            change(e) {
                this.page = e;
                this.savePage();
            },
            back() {
                this.$router.push('/home')
            },
            nextPage(item) {
                this.$router.push({path: '/detail', query: {visit_id: item.id}})
            },
            pre() {
                this.$refs.time.prev()
            },
            next() {
                this.$refs.time.next()
            }
        }
    }
</script>

<style scoped>
    .home-page {
        width: 100vw;
        height: 100vh;
        background: url(../assets/imgs/time.png);
        background-size: 100% 100%;
    }

    .home-page .title {
        color: #DB3127;
        font-size: 2.1vw;
        text-align: center;
        margin-top: -50px;
    }

    .home-page .back {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 2.6vw 2.6vw 1vw 0;
    }

    .home-page .back img {
        width: 2.1vw;
        margin-right: 10px;
        /*margin-top: 6px;*/
    }

    .home-page .back span {
        color: #DB3127;
        font-size: 1.8vw;

    }

    .list {
        display: flex;
        padding-right: 100px;
        margin-top: 10vh;
    }

    .sing {
        display: flex;
        position: relative;
        margin-left: 4%;
        width: 15vw;
    }

    .sing:nth-child(n+2) {
        margin-left: 6%;
    }

    .home-page .sing .content {
        width: 100%;
        border-radius: 0 0 20px 0;
        padding: 1vw;


    }

    .raidius {
        position: absolute;
        left: -0.56vw;
        top: -1.5vw;
        display: flex;
        flex-direction: column;
        z-index: 1;
        width: 5vw;
    }

    .xian {
        background: linear-gradient(#A7261E 0%, transparent 100%);
        width: 0.3vw;
        height: 40vh;
        margin-left: 0.32vw;
        margin-top: -10px;
    }

    .yuan {
        width: 1vw;
        height: 1vw;
        background: #A7261E;
        border-radius: 50%;
    }

    .dot {
        /*width: 40%;*/
        margin-left: -80%;
    }

    .content p {
        font-size: 1vw;
    }

    .content .h1 {
        margin: 15px 0;
    }

    .photo {
        width: 100%;
    }

    .home-page .sing:nth-child(even) .content {
        background: white;
        color: #DB3127;
    }

    .home-page .sing:nth-child(even) {
        margin-top: -2vw;


    }

    .home-page .sing:nth-child(odd) .content {
        background: #DB3127;
        color: white;
    }

    .home-page .sing:nth-child(odd) .content .photo {
        border: 1px solid white;
    }

    .home-page .sing:nth-child(even) .content .photo {
        border: 1px solid #DB3127;
    }

    .more {
        display: flex;
        justify-content: flex-end;
        margin-top: 0.9vw;
    }

    .more img {
        border-radius: 2vw;
        height: 24px;
        width: 62px;
        padding: 3px 15px;
        cursor: pointer;
    }

    .even img {
        background: #DB3127;
    }

    .odd img {
        background: white;
    }

    .sing:nth-child(2) .xian {
        height: 44vh;
    }

    .sing:nth-child(3) .xian {
        height: 38vh;
    }

    .sing:nth-child(4) .xian {
        height: 47vh;
    }

    .sing:nth-child(5) .xian {
        height: 34vh;
    }

    .pre, .next {
        position: fixed;
        width: 10vw;
        bottom: 3vw;
        cursor: pointer;
        z-index: 99;
    }

    .pre {
        left: 3vw;
    }

    .next {
        right: 3vw;
    }
</style>
